// Lightweight analytics helper. Uses Plausible if present, falls back to gtag.
// Usage: track('CTA - Start Free Trial - Hero', { origin: 'hero' })
export function track(event: string, props?: Record<string, any>) {
  try {
    // Plausible
    // @ts-ignore
    if (typeof window !== 'undefined' && typeof window.plausible === 'function') {
      // @ts-ignore
      window.plausible(event, { props });
      return;
    }
    // Google Analytics gtag
    // @ts-ignore
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      // @ts-ignore
      window.gtag('event', event, props || {});
      return;
    }
  } catch (_) {
    // no-op
  }
}

// Backwards-compatible named trackers expected by useAnalytics
export function trackEvent(event: string, props?: Record<string, any>) {
  track(event, props);
}

export function trackAuthEvent(action: string, props?: Record<string, any>) {
  track(`Auth - ${action}`, props);
}

export function trackJobEvent(action: string, props?: Record<string, any>) {
  track(`Job - ${action}`, props);
}

export function trackCandidateEvent(action: string, props?: Record<string, any>) {
  track(`Candidate - ${action}`, props);
}

export function trackInterviewEvent(action: string, props?: Record<string, any>) {
  track(`Interview - ${action}`, props);
}

export function trackSearchEvent(action: string, props?: Record<string, any>) {
  track(`Search - ${action}`, props);
}

export function trackFeatureEvent(action: string, props?: Record<string, any>) {
  track(`Feature - ${action}`, props);
}

export function trackErrorEvent(error: string | Error, props?: Record<string, any>) {
  const message = typeof error === 'string' ? error : error?.message || 'Unknown error';
  track(`Error - ${message}`, props);
}
